import { EditButton } from "@/components/button/SaveEditCancel/EditButton";
import styles from "./Permissions.module.css";
import { observer } from "mobx-react-lite";
import { userCurrentPanelState } from "@/stores/ComponentsState/UserCurrentPanelState";
import { permissionsStore } from "@/stores/PermissionsStore";
import { userStore } from "@/stores/UserStore";

export const Password = observer(() => {
  const permission = permissionsStore.getPermissionsByRoleId(userStore.role!);
  return (
    <div className={styles.iterationPermissions}>
      <div className={styles.titleSection}>
        <span>Пароль</span>
        <EditButton
          disabled={!permission?.typePermissions.users.edit}
          onClick={() => userCurrentPanelState.handleEdit("password")}
        >
          Изменить пароль
        </EditButton>
      </div>
    </div>
  );
});
